import { Tag, Button } from "antd";
import { WorkerStages, getWorkerStageLabel } from "@src/appV2/redesign/utils/worker";
import { FacilityStatusObj } from "@src/appV2/redesign/utils/facility";
import { SearchAttribute } from "./utils";

export function AccountSwitcherOptionGroup({ type, userDetails, handleChange }) {
  const listCount = userDetails?.list.length || 0;

  if (!userDetails.loading && !listCount) {
    return <p className="no-record">No Records</p>;
  }

  const stageDisplay = (user) => {
    const stage = type === "AGENT" ? user.stage : user.status;

    if (
      [
        WorkerStages.RESTRICTED,
        WorkerStages.DEACTIVATED,
        WorkerStages.SOFT_DELETED,
        FacilityStatusObj.ARCHIVED,
        FacilityStatusObj.SUSPENDED,
        FacilityStatusObj.TERMINATED,
      ].includes(stage)
    ) {
      return <Tag color="red">{getWorkerStageLabel(stage).toUpperCase()}</Tag>;
    }
  };

  const userKeys = ["name", "email", "phone", "userId", "pricingMsa"];
  return (
    <div>
      {userDetails?.list.map((user) => (
        <div
          className="account-select"
          onClick={() => handleChange({ user, type })}
          key={user._id}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            event.preventDefault();
            if (event.key === "Enter" || event.key === " ") {
              handleChange({ user, type });
            }
          }}
        >
          {userKeys.map((key) => SearchAttribute(user, key))}
          {stageDisplay(user)}
        </div>
      ))}
      {userDetails.loading || userDetails.isFetchingNextPage ? (
        <h4>Loading...</h4>
      ) : (
        <Button
          className="account-select"
          onClick={() => userDetails.fetchNextPage()}
          type="link"
          data-testid="account-more-btn"
        >
          {userDetails.hasNextPage && `Load more results`}
        </Button>
      )}
    </div>
  );
}
